export const FIELDS = {
    REQUISICAO: 'requisicao',
    EQUIPAMENTO: 'equipamento',
    OBSERVACAO: 'observacao',
    RESULTADO_EXAMES: 'resultadoExames',
};